/**
 * Conditional class name helper.
 * Combines clsx + tailwind-merge so duplicate Tailwind classes are deduped.
 */

import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
